import ReactDOM from 'react-dom/client';
import 'sonata-react-components/sonata-react-components.css';
import 'sonata-platform-components/sonata-platform-components.css';
import 'sonata-li/sonata-li.css';

import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
